// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".middle-align[data-v-491b7496]{vertical-align:middle}p[data-v-491b7496]{margin-top:12px;margin-bottom:12px}.new-owner-row[data-v-491b7496]{display:flex}.new-owner-row label[data-v-491b7496]{display:flex;align-items:center}.new-owner-row label span[data-v-491b7496]{margin-right:8px}.new-owner-row .multiselect[data-v-491b7496]{flex-grow:1;max-width:280px}.transfer-select-row span[data-v-491b7496]{margin-right:8px}\n", ""]);
// Exports
module.exports = exports;
